import { loadOrganizationDetails } from './check-auth';
import { permissionTypes } from 'drapcode-constant';
export const checkCodeExportPermission = () => {
  return checkPermission(permissionTypes.CODE_EXPORT);
};
export const checkDatabaseExportPermission = () => {
  return checkPermission(permissionTypes.DATABASE_EXPORT);
};
export const checkCollectionSnapPermission = () => {
  return checkPermission(permissionTypes.COLLECTION_SNAPSHOTS);
};
export const checkPageSnapPermission = () => {
  return checkPermission(permissionTypes.PAGE_SNAPSHOTS);
};
export const checkSnippetSnapPermission = () => {
  return checkPermission(permissionTypes.SNIPPET_SNAPSHOTS);
};
export const checkEncryptionPermission = () => {
  return checkPermission(permissionTypes.DATA_ENCRYPTION);
};
export const checkNotificationSettingPermission = () => {
  return checkPermission(permissionTypes.NOTIFICATION_SETTING);
};
export const checkSystemActivityPermission = () => {
  return checkPermission(permissionTypes.SYSTEM_ACTIVITY);
};
export const checkPWAPermission = () => {
  return checkPermission(permissionTypes.PWA_CONFIGURATION);
};
export const checkProfilerPermission = () => {
  return checkPermission(permissionTypes.PROFILER);
};
export const checkDeveloperAPIPermission = () => {
  return checkPermission(permissionTypes.DEVELOPER_API);
};
export const checkVersionPermission = () => {
  return checkPermission(permissionTypes.PROJECT_VERSION);
};
export const checkExternalAPIPermission = () => {
  return checkPermission(permissionTypes.EXTERNAL_API);
};
export const checkChatGPTPermission = () => {
  return checkPermission(permissionTypes.CHAT_GPT);
};
export const checkDataSourcePermission = () => {
  return checkPermission(permissionTypes.DATA_SOURCE);
};
export const checkCustomComponentPermission = () => {
  return checkPermission(permissionTypes.CUSTOM_COMPONENT);
};

export const checkGithubPermission = () => {
  console.log('Checking github export permission');
  const permissions = loadOrganizationDetails('permissions');
  console.log('permissions :>> ', permissions);
  if (!permissions || !Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(permissionTypes.GITHUB_EXPORT);
};

const checkPermission = (code) => {
  const subscription = loadOrganizationDetails('subscription');
  if (subscription === 'UNLIMITED') return true;
  const permissions = loadOrganizationDetails('permissions');
  if (!permissions) {
    return true;
  }
  return permissions.includes(code);
};
